import {get} from '@/lib/axios';

const rating = {
  async get_org_rating({page, pageSize}) {
    return get(`/rating`, {type: 'company', page, page_size: pageSize});
  },
  async get_internal_rating() {
    return get(`/rating`, {type: 'internal'});
  },
  async get_employees_rating({page, pageSize}) {
    return get(`/rating`, {type: 'org_employees', page, page_size: pageSize});
  },
  async get_common_rating({page, pageSize}) {
    return get(`/rating`, {type: 'common', page, page_size: pageSize});
  },
  async get_user_rating(id) {
    return get(`/rating/user/${id}`);
  },
  async get_company_rating(id) {
    return get(`/rating/company/${id}`);
  },
  async get_user_in_company_rating(id) {
    return get(`/rating/user/${id}/company`);
  },
  async get_rating(id) {
    return get(`/user/points/rating?userId=${id}`);
  },
};

export {rating as default};
